module.exports = __webpack_public_path__ + "img/logo.2ede10ba.svg";